import { Component, Input, OnInit } from '@angular/core';
import { Reservation } from 'src/app/core/reservation.service';

@Component({
  selector: 'app-contract-notes',
  templateUrl: './contract-notes.component.html',
  styleUrls: ['./contract-notes.component.scss'],
})
export class ContractNotesComponent implements OnInit {
  @Input() reservation: Reservation;

  constructor() {}

  ngOnInit(): void {}
}
